module.exports = __webpack_public_path__ + "static/media/bus-stop.f81a21a8.svg";